import { Combobox } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { getOutletDisplayText } from '../Layout/utils';

export interface OutletSearchComboboxProps {
  allowedCompanies: Array<any>;
  onSelectedCompanyChange: (companyName: string) => void;
  selectedCompany: any;
}

export const OutletSearchCombobox: FunctionComponent<OutletSearchComboboxProps> = (props) => {
  const { t } = useTranslation();

  const mapToValue = (company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData) => ({
    key: company.milesCompanyId!,
    value: getOutletDisplayText(company),
  });

  return (
    <Combobox
      id="outlet-search-combobox"
      name="outlet-search-combobox"
      noOptionsMessage={t('outletPage:search:noOptionsMessage')}
      multiple={false}
      value={[mapToValue(props.selectedCompany)]}
      onChange={(value) => {
        if (value.length) {
          props.onSelectedCompanyChange(value[0].key);
        }
      }}
      options={props.allowedCompanies.map((company) => mapToValue(company))}
      placeholder={t('outletPage:search:placeholder')}
      searchInputLabel={t('outletPage:search:searchInputLabel')}
      searchable
    />
  );
};
